import { render, staticRenderFns } from "./UserAddAccount.vue?vue&type=template&id=513b7ec2&"
import script from "./UserAddAccount.vue?vue&type=script&lang=js&"
export * from "./UserAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAddAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports